import React from 'react';
import Game from '../../Game/Game';
import { fetchPathGame, sendPathGameScoresToServer } from '../../../api/fetchPathGame';

const PathCheckGame = ({ userId, step, allPhrasesCount, onExit, onBack, onGoPremium = null }) => {
  const handleExit = typeof onExit === 'function'
    ? onExit
    : (typeof onBack === 'function' ? onBack : () => {});
  const totalItems = Number(step?.total_items ?? step?.total_count ?? 0);
  const progressCount = Number(step?.progress_count ?? 0);
  const remainingPhrasesForStep = Math.max(totalItems - progressCount, 0);

  const fixedDifficulty = step?.step_type === 'medium' ||
    step?.step_type === 'review_medium' ||
    step?.step_type === 'level_review_medium'
    ? 'medium'
    : 'easy';

  const sendScoresAdapter = (payload) => {
    const correctPhrases = Math.max((Number(payload.round) || 1) - 1, 0);
    const totalAttempts = Math.max(Number(payload.phrasesCount) || 0, correctPhrases);

    return sendPathGameScoresToServer({
      gameId: payload.gameId,
      userId: payload.userId,
      pathStepId: step?.id,
      stepId: payload.stepId,
      completeGame: true,
      score: payload.score,
      phrasesCount: totalAttempts,
      round: correctPhrases,
      difficulty: payload.difficulty,
      gameDuration: payload.gameDuration,
      averagePhraseTime: payload.averagePhraseTime
    });
  };

  return (
    <Game
      userId={userId}
      gameLevel={null}
      allPhrasesCount={allPhrasesCount}
      onExit={handleExit}
      onGoPremium={onGoPremium}
      fetchGameFn={fetchPathGame}
      sendScoresFn={sendScoresAdapter}
      recordSource="pathgame"
      fixedDifficulty={fixedDifficulty}
      pathStepId={step?.id}
      stepGoalPhrases={remainingPhrasesForStep}
    />
  );
};

export default PathCheckGame;
